import React, {useState, useContext} from 'react'
import './css.css';
import Buttons from './Buttons'
import ProductsContext from '../Context/AppContext';
import Burger from './Burger'

export default function Nav() {
    const [classButtons, setClassButtons] = useState('');

    
  const {setProducts, setCantProdView,category, setCategory, setScrollTop, setSizes} = useContext(ProductsContext);

    const handleChangeCategory = (e) => {
        const cat = e.target.id;
        onClickBurger();
        if(cat !== category){
            setCategory(cat);
            setCantProdView(6);
            setSizes('');
            setScrollTop(0);
            setProducts(null);
        }
    };


    const onClickBurger = () => {
        if(classButtons === '') {
            setClassButtons('toggle');
        }
        else{
            setClassButtons('');
        }
    }
    
    
    return (
        <div className="content-nav">
            <Buttons onClick={handleChangeCategory} category={category} classButtons={classButtons}/>
            <Burger classButtons={classButtons} onClickBurger={onClickBurger} />
        </div>
    )
}
